//设置商品
export const SET_SKUID = "SET_SKUID";
//设置商品
export const SET_ACTIVITYID = "SET_ACTIVITYID";
//设置商品
export const SET_SKUNUM = "SET_SKUNUM";



// WEBPACK FOOTER //
// ./src/store/spell-buy/type.js